/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  PatchedWhatsNewStateRequest,
  UserDetail,
  WhatsNewState
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type meRetrieveResponse200 = {
  data: UserDetail
  status: 200
}

export type meRetrieveResponseSuccess = (meRetrieveResponse200) & {
  headers: Headers;
};
;

export type meRetrieveResponse = (meRetrieveResponseSuccess)

export const getMeRetrieveUrl = () => {




  return `/api/v1/me/`
}

export const meRetrieve = async ( options?: RequestInit): Promise<meRetrieveResponse> => {

  return customFetch<meRetrieveResponse>(getMeRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}


export type meConsultantGroupRetrieveResponse303 = {
  data: void
  status: 303
}

export type meConsultantGroupRetrieveResponse404 = {
  data: void
  status: 404
}

;
export type meConsultantGroupRetrieveResponseError = (meConsultantGroupRetrieveResponse303 | meConsultantGroupRetrieveResponse404) & {
  headers: Headers;
};

export type meConsultantGroupRetrieveResponse = (meConsultantGroupRetrieveResponseError)

export const getMeConsultantGroupRetrieveUrl = () => {




  return `/api/v1/me/consultant-group/`
}

export const meConsultantGroupRetrieve = async ( options?: RequestInit): Promise<meConsultantGroupRetrieveResponse> => {

  return customFetch<meConsultantGroupRetrieveResponse>(getMeConsultantGroupRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}


export type meWhatsNewRetrieveResponse200 = {
  data: WhatsNewState
  status: 200
}

export type meWhatsNewRetrieveResponseSuccess = (meWhatsNewRetrieveResponse200) & {
  headers: Headers;
};
;

export type meWhatsNewRetrieveResponse = (meWhatsNewRetrieveResponseSuccess)

export const getMeWhatsNewRetrieveUrl = () => {




  return `/api/v1/me/whats-new/`
}

export const meWhatsNewRetrieve = async ( options?: RequestInit): Promise<meWhatsNewRetrieveResponse> => {

  return customFetch<meWhatsNewRetrieveResponse>(getMeWhatsNewRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}


export type meWhatsNewPartialUpdateResponse200 = {
  data: WhatsNewState
  status: 200
}

export type meWhatsNewPartialUpdateResponseSuccess = (meWhatsNewPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type meWhatsNewPartialUpdateResponse = (meWhatsNewPartialUpdateResponseSuccess)

export const getMeWhatsNewPartialUpdateUrl = () => {




  return `/api/v1/me/whats-new/`
}

export const meWhatsNewPartialUpdate = async (patchedWhatsNewStateRequest?: PatchedWhatsNewStateRequest, options?: RequestInit): Promise<meWhatsNewPartialUpdateResponse> => {

  return customFetch<meWhatsNewPartialUpdateResponse>(getMeWhatsNewPartialUpdateUrl(),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedWhatsNewStateRequest)
  }
);}


